import {
  TextField,
  ReferenceField,
  useRecordContext,
  SimpleShowLayout,
  ArrayField,
  WithListContext,
} from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import ExamsSlotsShow from "./ExamsSlotsShow";
import { CampaignExamButtons, ExamStatusSymbols } from "../../Show/";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const ExamListShow = () => {
  const record = useRecordContext();

  const campaignIsStarted = record?.campaignIsStarted;
  const hasRoomsWithCandidates = record?.rooms?.some(r => r.candidatesCount > 0);

  if (!record?.exams) return null;

  const anyExamPassed = record?.exams?.some(exam => exam.examDays?.some(day => day.examPassed));

  return (
    <SimpleShowLayout sx={{ p: 0 }}>
      {anyExamPassed && <ExamStatusSymbols />}
      <ArrayField
        source="exams"
        label={false}
      >
        <WithListContext
          render={({ data }) =>
            data.map((exam, index) => (
              <Accordion
                key={index}
                sx={{ mb: 2 }}
              >
                <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#4E2683" }} />}>
                  <ReferenceField
                    record={exam}
                    source="examId"
                    reference={administrationRequests.getExamsSelect()}
                  >
                    <TextField
                      source="name"
                      color={"#4E2683"}
                      sx={{ fontWeight: "bold" }}
                    />
                  </ReferenceField>
                </AccordionSummary>
                <AccordionDetails>
                  <SimpleShowLayout
                    sx={{ p: 0 }}
                    record={exam}
                    key={index}
                  >
                    <Box
                      sx={{
                        mt: 1,
                        mb: 4,
                        border: "2px solid #E0E0E0",
                        borderRadius: 2,
                        p: 2,
                      }}
                    >
                      <Grid
                        container
                        spacing={2}
                      >
                        <Grid
                          item
                          xs={12}
                          md={2.4}
                        >
                          <Typography
                            fontWeight="bold"
                            color="text.primary"
                            sx={{ mb: 1 }}
                          >
                            Изпит
                          </Typography>
                          <ReferenceField
                            source="examId"
                            reference={administrationRequests.getExamsSelect()}
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={2.4}
                        >
                          <Typography
                            fontWeight="bold"
                            color="text.primary"
                            sx={{ mb: 1 }}
                          >
                            Тип на изпита
                          </Typography>
                          <ReferenceField
                            source="examTypeId"
                            reference={administrationRequests.getExamTypesSelect()}
                          >
                            <TextField source="nameBg" />
                          </ReferenceField>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={2.4}
                        >
                          <Typography
                            fontWeight="bold"
                            color="text.primary"
                            sx={{ mb: 1 }}
                          >
                            Категория на изпита
                          </Typography>
                          <ReferenceField
                            source="examCategoryId"
                            reference={administrationRequests.getExamCategoriesSelect()}
                          >
                            <TextField source="nameBg" />
                          </ReferenceField>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={2.4}
                        >
                          <Typography
                            fontWeight="bold"
                            color="text.primary"
                            sx={{ mb: 1 }}
                          >
                            Език на обучение
                          </Typography>
                          <ReferenceField
                            source="instructionLanguageId"
                            reference={administrationRequests.getInstructionLanguagesSelect()}
                          >
                            <TextField source="name" />
                          </ReferenceField>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={2.4}
                        >
                          <Typography
                            fontWeight="bold"
                            color="text.primary"
                            sx={{ mb: 1 }}
                          >
                            Брой записани
                          </Typography>
                          <TextField source="enrolledCandidatesCount" />
                        </Grid>

                        {exam.gradingScaleId && (
                          <Grid
                            item
                            xs={12}
                            md={3}
                          >
                            <Typography
                              fontWeight="bold"
                              color="text.primary"
                              sx={{ mb: 1 }}
                            >
                              Скала за оценяване
                            </Typography>
                            <ReferenceField
                              source="gradingScaleId"
                              reference={administrationRequests.getGradingScalesSelect()}
                            >
                              <TextField source="name" />
                            </ReferenceField>
                          </Grid>
                        )}
                      </Grid>
                      <CampaignExamButtons isFinished={record.isFinished} />
                      <Box sx={{ mt: 2 }}>
                        <ExamsSlotsShow
                          campaignIsStarted={campaignIsStarted}
                          hasRoomsWithCandidates={hasRoomsWithCandidates}
                        />
                      </Box>
                    </Box>
                  </SimpleShowLayout>
                </AccordionDetails>
              </Accordion>
            ))
          }
        />
      </ArrayField>
    </SimpleShowLayout>
  );
};

export default ExamListShow;
